// extracted by mini-css-extract-plugin
export default {"imgdiv":"_50b6a90769 b1019e7feb","img":"_4e9e87beb7 _8447fb36a7"};